import React, { useState, useEffect } from 'react';
import { Layout, Menu, Avatar, Dropdown, Typography, Space, Button, message } from 'antd';
import {
  DashboardOutlined,
  AppstoreOutlined,
  TagsOutlined,
  SettingOutlined,
  UserOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  HomeOutlined,
  FundOutlined,
  UnorderedListOutlined
} from '@ant-design/icons';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import './AdminLayout.css';

const { Header, Sider, Content } = Layout;
const { Title } = Typography;

const AdminLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // 检查是否有token
    const token = localStorage.getItem('admin_token');
    if (!token) {
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    message.success('退出成功');
    navigate('/admin/login');
  };

  const handleGoHome = () => {
    window.open('/', '_blank');
  };

  const userMenuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: '个人资料',
      onClick: () => navigate('/admin/profile'),
    },
    {
      key: 'divider',
      type: 'divider' as const,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ];

  const menuItems = [
    {
      key: '/admin/dashboard',
      icon: <DashboardOutlined />,
      label: '仪表盘',
    },
    {
      key: '/admin/categories',
      icon: <TagsOutlined />,
      label: '分类管理',
    },
    {
      key: '/admin/apps',
      icon: <AppstoreOutlined />,
      label: 'APP管理',
    },
    {
      key: '/admin/ads',
      icon: <FundOutlined />,
      label: 'Ad Management',
    },
    {
      key: '/admin/custom-lists',
      icon: <UnorderedListOutlined />,
      label: '自定义列表',
    },
    {
      key: '/admin/settings',
      icon: <SettingOutlined />,
      label: '系统设置',
    },
  ];

  const handleMenuClick = ({ key }: { key: string }) => {
    navigate(key);
  };

  const getSelectedKeys = () => {
    const path = location.pathname;
    // 找到匹配的菜单项
    const matchedItem = menuItems.find(item => path.startsWith(item.key));
    return matchedItem ? [matchedItem.key] : [];
  };

  return (
    <Layout className="admin-layout">
      <Sider
        trigger={null}
        collapsible
        collapsed={collapsed}
        className="admin-sider"
        width={240}
        collapsedWidth={80}
      >
        <div className="admin-logo">
          <Space>
            <Avatar
              size={collapsed ? 32 : 40}
              icon={<AppstoreOutlined />}
              style={{ backgroundColor: '#1890ff' }}
            />
            {!collapsed && (
              <Title level={4} className="logo-title">
                管理后台
              </Title>
            )}
          </Space>
        </div>

        <Menu
          theme="dark"
          mode="inline"
          selectedKeys={getSelectedKeys()}
          items={menuItems}
          onClick={handleMenuClick}
          className="admin-menu"
        />
      </Sider>

      <Layout className="admin-main">
        <Header className="admin-header">
          <div className="header-left">
            <Button
              type="text"
              icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
              onClick={() => setCollapsed(!collapsed)}
              className="collapse-btn"
            />
          </div>

          <div className="header-right">
            <Space size="middle">
              <Button
                type="text"
                icon={<HomeOutlined />}
                onClick={handleGoHome}
                className="home-btn"
              >
                前台首页
              </Button>

              <Dropdown
                menu={{ items: userMenuItems }}
                placement="bottomRight"
                trigger={['click']}
              >
                <div className="user-info">
                  <Space>
                    <Avatar icon={<UserOutlined />} />
                    <span className="username">管理员</span>
                  </Space>
                </div>
              </Dropdown>
            </Space>
          </div>
        </Header>

        <Content className="admin-content">
          <div className="content-wrapper">
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AdminLayout;
